import moment from 'moment-timezone';
import XlinkAPI from '~/app/api/xlinkAPI';

// TODO: this should be moved back to general when the 'moment' package is phased out
/**
 * Convert the passed in startDate and endDate to
 * unix timestamp. Get the current date in unix timestamp.
 * Then check if current date is between the startDate
 * and endDate to display the header message.
 */
export const checkStartEndDate = (
  startDate,
  endDate,
  shouldLogData,
  forceEnableMaintenanceMode,
) => {
  if (forceEnableMaintenanceMode) {
    return true;
  }
  const currentTimestamp = moment.utc().valueOf();
  // temp logs
  if (shouldLogData) {
    XlinkAPI.logErrorMessage(
      'maintenanceModeHelper - Logging Time and Date for Maintenance Mode - Before UTC conversion',
      `maintenanceModeHelper - one - Data ->  startDate: ${startDate}, endDate: ${endDate}`,
      0,
    );
  }
  startDate = moment.utc(startDate).valueOf();
  endDate = moment.utc(endDate).valueOf();
  // temp logs
  if (shouldLogData) {
    XlinkAPI.logErrorMessage(
      'maintenanceModeHelper - Logging Time and Date for Maintenance Mode',
      `maintenanceModeHelper - two - Data -> currentTimestamp: ${currentTimestamp}, startDate: ${startDate}, endDate: ${endDate}`,
      0,
    );
  }
  // Both startDate and endDate exist so we check if current date
  // is between startDate and endDate.
  if (startDate && endDate) {
    if (currentTimestamp > startDate && currentTimestamp < endDate) {
      return true;
    }
  }
  // Only startDate was provided so we check if current date is on or
  // after startDate.
  else if (startDate && !endDate) {
    if (currentTimestamp > startDate) {
      return true;
    }
  }
  // Only endDate is provided, so we show the message immediately
  // and will hide the message on the end date timestamp.
  else if (!startDate && endDate) {
    if (currentTimestamp <= endDate) {
      return true;
    }
  }

  return false;
};

// TODO: this should be moved back to general when the 'moment' package is phased out
export const isCurrentTimePriorToGivenTime = (givenTime, difference = 0, shouldLogData) => {
  const currentTime = moment.utc();
  const givenMoment = moment.utc(givenTime);

  const diffMinutes = givenMoment.diff(currentTime, 'minutes');
  // temp logs
  if (shouldLogData) {
    XlinkAPI.logErrorMessage(
      'maintenanceModeHelper - Logging isCurrentTimePriorToGivenTime variables',
      `maintenanceModeHelper - three - Data -> currentTime: ${currentTime}, givenMoment: ${givenMoment}, givenTime: ${givenTime}, diffMinutes: ${diffMinutes}`,
      0,
    );
  }

  return diffMinutes <= difference;
};

// TODO: this should be moved back to general when the 'moment' package is phased out
/**
 * Takes a string date format and returns unix timestamp.
 *
 * Example:
 * const strDateUnixFormat = dateStrToUnixTimestamp("2019-10-24");
 *
 * @param {*} strDate
 */
export const dateStrToUnixTimestamp = strDate => {
  return moment.utc(strDate).valueOf();
};

// mimics the 'Empty Cache and Hard Reload' process
export const forceReloadAndClearCache = async () => {
  try {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }

    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const reg of registrations) {
        await reg.unregister();
      }
    }

    window.location.reload(true);
  } catch (error) {
    console.error('Failed clearing cache, forcing reload', error);
    window.location.reload(true);
  }
};
